export const isStagingBranch = () => {
  const hostname = window.location.hostname;
  return (
    hostname === "sudowrite-early-access.onrender.com" ||
    hostname === "sudowrite-backend.onrender.com" ||
    hostname.match(/sudowrite-pr-\d+.onrender.com/)
  );
};
